import { stringToDateObject } from "./dateObjectUtils";
import { Dayjs } from "dayjs";

export const areValuesSame = (...values: Array<unknown>): boolean => {
    if (values.length === 1) {
        return true;
    }
    const firstValue = values[0];
    for (const value of values) {
        if (firstValue !== value) {
            return false;
        }
    }
    return true;
};

export function toDateObjectOrNull(datetime?: string): Dayjs | null {
    return stringToDateObject(datetime) ?? null;
}
